import React from 'react';
import { Box, Stack, Text } from '@mantine/core';
import { CategorySection } from './CategorySection';
import { RuleBlock } from './RuleBlock';
import { SuggestedPriceCostFloorCallout } from './SuggestedPriceCostFloorCallout';

export function SuggestedPriceFormulaContent() {
    return (
        <Stack gap={0} className="min-w-[min(100vw-2rem,22rem)] max-w-[22rem]">
            <Box
                px="md"
                py="sm"
                className="shrink-0 border-b border-primary/10 bg-primary/5"
            >
                <Text size="sm" fw={700} c="primary">
                    Suggested price
                </Text>
                <Text size="xs" c="dimmed" mt={4} lh={1.55}>
                    Calculated from the lowest competitor price, excluding N/A
                    values and zero prices.
                </Text>
            </Box>

            <Box className="bg-[#f4f5f7] px-3 py-3">
                <Stack gap="sm">
                    <CategorySection title="Bricks category">
                        <RuleBlock
                            condition="Always applies"
                            formula="competitor price − 0.01"
                            example="e.g. R54.10 → R54.09 → round down to R53.99"
                        />
                    </CategorySection>

                    <CategorySection title="All other categories">
                        <RuleBlock
                            condition="When competitor price is R50 or less"
                            formula="competitor price − 0.05"
                            example="e.g. R39.52 → R39.47 → round down to R38.95"
                            showDivider
                        />
                        <RuleBlock
                            condition="When competitor price is above R50"
                            formula="round up to whole number − 1.05"
                            example="e.g. R52.30 → R53 − 1.05 = R51.95"
                        />
                    </CategorySection>

                    <SuggestedPriceCostFloorCallout />
                </Stack>
            </Box>
        </Stack>
    );
}
